import { render, staticRenderFns } from "./CreateInstruments.vue?vue&type=template&id=a9ba4cc2&scoped=true"
import script from "./CreateInstruments.vue?vue&type=script&lang=js"
export * from "./CreateInstruments.vue?vue&type=script&lang=js"
import style0 from "./CreateInstruments.vue?vue&type=style&index=0&id=a9ba4cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba4cc2",
  null
  
)

export default component.exports